import { Option, Product } from '@thro-types/leihbar';

import { TFunction } from 'i18next';
import { pick } from 'lodash';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const optionValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    title: yup
      .string()
      .required(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.option.create.title())),
    description: yup
      .string()
      .required(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.option.create.description())),
    amount: yup
      .number()
      .required(t(translations.validation.required()))
      .label(t(translations.pages.leihbar.option.create.count())),
    image: yup.mixed(),
    productId: yup.number()
  });

export const initialValues = (product: Product, initialOption?: Option) => {
  return initialOption
    ? {
        ...pick(initialOption, ['id', 'title', 'description', 'amount', 'image']),
        productId: initialOption.product?.id || product.id
      }
    : { title: '', description: '', amount: '', image: 'noImage', productId: product.id };
};
